// _           __   ___   _____    __   _   _   __   _   _____
// | |        / /  /   | |  _  \  |  \ | | | | |  \ | | /  ___|
// | |  __   / /  / /| | | |_| |  |   \| | | | |   \| | | |
// | | /  | / /  / / | | |  _  /  | |\   | | | | |\   | | |  _
// | |/   |/ /  / /  | | | | \ \  | | \  | | | | | \  | | |_| |
// |___/|___/  /_/   |_| |_|  \_\ |_|  \_| |_| |_|  \_| \_____/

// THIS FILE IS AUTO GENERATED!!!!!!
// DO NO EDIT IT HERE.

// THE TEMPLATE IS AT: tasks/pkg/illustration-template/src/index.tsx

import baseIllustration from '@bubble-ui/temp-illustration-base';
var IllustrationAwaitingCourierPath = 'M9.901 38.846V12.5H99.01v64.842A10.386 10.386 0 0188.9 87.738h-49.01a28.613 28.613 0 007.139-6.931h41.584a3.465 3.465 0 003.465-3.277v-58.1H66.337v22.941L54.95 36.678l-11.386 5.693v-22.94H16.832v16.693A28.613 28.613 0 009.9 38.846zm45.05-9.92l4.455 2.228V19.43h-8.911v11.723l4.456-2.228zM0 63.986c0-13.124 10.639-23.763 23.762-23.763 13.124 0 23.763 10.639 23.763 23.762 0 13.124-10.639 23.763-23.763 23.763C10.64 87.748 0 77.108 0 63.984zm40.594 0c0-9.297-7.536-16.832-16.832-16.832-9.296 0-16.831 7.535-16.831 16.831s7.535 16.832 16.831 16.832 16.832-7.536 16.832-16.832zm-14.337 1.08v-11.26h-6v12.377l.008.216a3 3 0 00.724 1.747l6.356 7.347 4.538-3.926-5.626-6.502z';
var IllustrationAwaitingCourier = baseIllustration('IllustrationAwaitingCourier', {
  getPath: () => IllustrationAwaitingCourierPath
}, 'ColoredIllustrationAwaitingCourier');

/**
 * @deprecated this component is outdated and will be removed with v6.0.0
 */
export default IllustrationAwaitingCourier;
//# sourceMappingURL=index.js.map